import React from "react";
import EventPopupSkeleton from "./skeleton/EventPopupSkeleton";
import ScrollContent from "components/UI/ScrollContent";
import { Link, useHistory } from "react-router-dom";
import useFetch from "hooks/useFetch";
import useGaPageView from "hooks/useGaPageView";
import dateStart from "assets/images/date-start.svg";
import dateEnd from "assets/images/date-end.svg";
import arrowRight from "assets/images/arrow-right.svg";
import placeholder1000x625 from "assets/placeholder/1000x625.png";
import styles from "./EventDetail.module.css";
import playClickSpecial from "utils/playClickSpecial";
import { gaSettings } from "config/constants";

const EventPopup = ({ apiPath, id, code, titleButton }) => {
  const history = useHistory();
  const pathname = history.location.pathname.replace(/\/+$/, "");
  const [error, loading, details] = useFetch(apiPath + "/" + id);

  let gaTitle = null;
  let gaLocation = null;

  if (details && details.title && details.type) {
    gaTitle =
      details.type === "promotion"
        ? gaSettings.promotionDetail.title
        : gaSettings.eventDetail.title;
    gaLocation =
      details.type === "promotion"
        ? gaSettings.promotionDetail.location + details.title
        : gaSettings.eventDetail.location + details.title;
  }

  useGaPageView({ gaTitle, gaLocation });

  if (loading) {
    return <EventPopupSkeleton />;
  }

  if (error) {
    history.go(0);
  }

  return (
    <div className={styles.DetailPopup}>
      {details && (
        <>
          <h2 className={styles.Title}> {details.title}</h2>
          <img
            src={details.thumb || placeholder1000x625}
            alt="shop-logo"
            className={styles.Thumbnail}
          />
          <div className={styles.DateRow}>
            <div className={styles.DateItem}>
              <img src={dateStart} alt="icon" />
              <span>{details.start_date}</span>
            </div>
            <div className={styles.DateItem}>
              <img src={dateEnd} alt="icon" />
              <span>{details.end_date}</span>
            </div>
          </div>
          <ScrollContent maxHeight={"112px"}>
            <div
              className={styles.Content}
              dangerouslySetInnerHTML={{ __html: details.content }}
            ></div>
          </ScrollContent>
          {code && (
            <div className="text-center">
              <Link
                to={{
                  pathname: `${pathname}/${id}`,
                  search: `?code=${code}`,
                }}
                className={"btn " + styles.Button}
                onClick={playClickSpecial}
              >
                {titleButton}
                <img style={{ marginLeft: 5 }} src={arrowRight} alt="icon" />
              </Link>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default EventPopup;
